// src/context/LevelUnitContext.tsx

import React, { createContext, useState, useContext, ReactNode } from 'react';

interface LevelUnitContextType {
  level: string;
  unit: string;
  isRandom: boolean; // Add this line
  setLevel: (level: string) => void;
  setUnit: (unit: string) => void;
  setIsRandom: (isRandom: boolean) => void; // Add this line
}

const LevelUnitContext = createContext<LevelUnitContextType | undefined>(undefined);

export const LevelUnitProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [level, setLevel] = useState<string>('');
  const [unit, setUnit] = useState<string>('');
  const [isRandom, setIsRandom] = useState<boolean>(false); // Add this line

  return (
    <LevelUnitContext.Provider value={{ level, setLevel, unit, setUnit, isRandom, setIsRandom }}>
      {children}
    </LevelUnitContext.Provider>
  );
};

export const useLevelUnit = () => {
  const context = useContext(LevelUnitContext);
  if (!context) {
    throw new Error('useLevelUnit must be used within a LevelUnitProvider');
  }
  return context;
};
